import React from 'react'
import { MaterialTable } from '../generic'
import { printCurrency } from '../../lib/helpers'
import { format } from 'date-fns'

const cols = [
  {
    Header: 'Benefit',
    accessor: 'benefit',
    Cell: ({ value }) => (value ? value.replace(/_/g, ' ') : '-'),
  },
  {
    Header: 'Claim Reason',
    accessor: 'claimReason',
    Cell: ({ value }) => (value ? value.replace(/_/g, ' ') : '-'),
  },
  {
    Header: 'Cover Amount',
    accessor: 'coverAmount',
    Cell: ({ value }) => (value ? printCurrency(value) : '-'),
  },
  {
    Header: 'Premium',
    accessor: 'premiumAmount',
    Cell: ({ value }) => (value ? printCurrency(value) : '-'),
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ value }) => (value ? value.replace(/_/g, ' ') : '-'),
  },
  {
    Header: 'Waiting Period',
    accessor: 'waitingPeriodPayments',
    Cell: ({ value, row }) => {
      if (!value) return '-'
      const completed = row.original.waitingPeriodPaymentsCompleted || 0
      return `${completed} / ${value}`
    },
  },
  {
    Header: 'Term (months)',
    accessor: 'term',
    Cell: ({ value }) => (value != null ? value : '-'),
  },
  {
    Header: 'Active Since',
    accessor: 'startedAt',
    Cell: ({ value }) => (value ? format(value, 'yyyy-LL-dd') : '-'),
  },
]

const summaryCols = [
  {
    Header: 'Benefit',
    accessor: 'benefit',
    Cell: ({ value }) => (value ? value.replace(/_/g, ' ') : '-'),
  },
  {
    Header: 'Claim Reason',
    accessor: 'claimReason',
    Cell: ({ value }) => (value ? value.replace(/_/g, ' ') : '-'),
  },
  {
    Header: 'Covered',
    accessor: 'coveredAmount',
    Cell: ({ value }) => printCurrency(value),
  },
  {
    Header: 'In Waiting Period',
    accessor: 'inWaitingPeriodAmount',
    Cell: ({ value }) => printCurrency(value),
  },
]

const summarizeBenefits = benefits => {
  const summaryByKey = new Map()

  benefits.forEach(({ benefit, claimReason, coverAmount, status }) => {
    if (status !== 'COVERED' && status !== 'IN_WAITING_PERIOD') return

    const key = `${benefit}|${claimReason}`
    if (!summaryByKey.has(key)) {
      summaryByKey.set(key, { benefit, claimReason, coveredAmount: 0, inWaitingPeriodAmount: 0 })
    }

    const summary = summaryByKey.get(key)
    if (status === 'COVERED') summary.coveredAmount += coverAmount || 0
    else summary.inWaitingPeriodAmount += coverAmount || 0
  })

  return Array.from(summaryByKey.values())
}

const InsuranceBenefits = ({ benefits }) => {
  if (!benefits || benefits.length === 0) return null

  const summary = summarizeBenefits(benefits)

  return (
    <>
      <div style={{ fontVariant: 'small-caps', fontSize: 21, fontWeight: 400, marginTop: 16 }}>
        Benefit Summary
      </div>
      <MaterialTable columns={summaryCols} data={summary} />
      <div style={{ fontVariant: 'small-caps', fontSize: 21, fontWeight: 400, marginTop: 16 }}>
        Benefits
      </div>
      <MaterialTable columns={cols} data={benefits} />
    </>
  )
}

export default InsuranceBenefits
